import styled from "styled-components";
import colors from "../../assets/styles/colors";

export const SelectInputSelectorOffice = styled.input`
  width: 0px;
  border: 0px;
  height: 0px; 
`;

export const SelectShowOptionSelectedMessageErrorOffice = styled.small`
  font-size: 12px;
  color: ${colors.bgDanger};
  line-height: 14px;
  margin: 5px 8px;
  opacity: ${prop => prop.error ? '1' : '0'};
  transition: ease-in-out .2s;
`;

export const SelectShowOptionSelectOffice = styled.div`
  width: 551px;
  position: relative;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${prop => prop.disabledField ? colors.readOnlyBorder : colors.darkblue};
  margin-top: 12px;
  padding: 12px 10px;
  height: 45px;
  cursor:  ${prop => prop.disabledField ? 'initial' : 'pointer'};
  border-radius: 8px;
  transition: ease-in-out .2s;
  background: ${prop => prop.disabledField ? colors.readOnlyBorder : colors.white};
  height: 44px;

  svg {
    transform: ${prop => prop.open ? 'none' : 'rotate(180deg) !important'};
    transition: ease-in-out .2s;
  }

  &.error {
    border-bottom: solid 5px ${colors.bgDanger}; 
  }
`;

export const SelectShowOptionSelectedOffice = styled.div`
  color: ${colors.darkblue};
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0.03em;

  &.default {
    color: ${colors.darkblue};
    opacity: 0.9;
  }
`;

export const SelectShowOptionContentOffice = styled.div`
  width: 100%;
  left: 0;
  position: absolute;
  display: block;
  top: 50px;
  display: flex;
  overflow-y: scroll;
  overflow-x: hidden;
  flex-direction: column; 
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 10px;
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  max-height: 210px;
  overflow: ${prop => prop.open ? '' : 'hidden'};
  z-index: 99;

  &::-webkit-scrollbar {
    width: 4px;
    background: ${colors.white}; 
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${colors.bgSecondary}; 
    border-radius: 10px;
  }
`;

export const SelectShowOptionSelectOptionOffice = styled.div`
  padding: 10px;
  background: ${prop => prop.active ? colors.bgFilterSelected : colors.white};
  transition: ease-in-out .2s;
  z-index: 999;

  &:hover {
    background: ${colors.bgSuccess};
  }

  &:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  &:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

export const SelectContainerOffice = styled.div`
  display: flex;
  flex-direction: column;
  transition: ease-in-out .2s;
`;

export const SelectLabelOffice = styled.label`
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.03em;
  color: ${colors.textPrimary};
  opacity: 0.9;
  text-transform: uppercase;
`;
